import { render } from "./AddressBlock.vue?vue&type=template&id=148b352a&ts=true"
import script from "./AddressBlock.vue?vue&type=script&lang=ts"
export * from "./AddressBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__